module.exports = __webpack_public_path__ + "static/img/1000000491_green.4d382096.jpg";